import { Component } from '@angular/core';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { ITooltipParams } from 'ag-grid-community';
import { DateTime } from 'luxon';
import { LocationCamera } from '../../../../types';

@Component({
  selector: 'app-pan-cell-connection-type-tooltip',
  imports: [],
  templateUrl: './cell-connection-type-tooltip.component.html',
})
export class CellConnectionTypeTooltipComponent implements ITooltipAngularComp {
  public params!: ITooltipParams<LocationCamera>;

  agInit(params: ITooltipParams<LocationCamera>) {
    this.params = params;
  }

  public get detectedAt(): string | null {
    const ispDetectedAt = this.params.data?.isp_detected_at;
    if (!ispDetectedAt) return null;
    return DateTime.fromJSDate(new Date(ispDetectedAt)).toFormat('MMM d, yyyy h:mm a');
  }
}
